"use client";

import "./advisor_security.scss";

import { ReactElement, useState } from "react";
import { Container } from "@/elements/container/container";
import { Stack } from "@/elements/stack/stack";
import { Text } from "@/elements/text/text";
import { i18n } from "@/model/i18n";
import { Icon } from "@/elements/icon/icon";
import { CollapsePanel } from "@/elements/collapse_panel/collapse_panel";
import { Spacer } from "../../../elements/spacer/spacer";

export function AdvisorSecurity(): ReactElement {
  const [panels, setPanels] = useState({
    panel1: false,
    panel2: false,
    panel3: false,
  });

  return (
    <section aria-label="advisor-security" className="advisor-security">
      <Container>
        <Stack size={60} desktopSize={80}>
          <Stack size={32}>
            <Text
              htmlElement="h2"
              type="h2-xbold"
              color="neutral-on-surface"
              uppercase
            >
              {i18n.t("pages.advisor.security")}
            </Text>
            <Text htmlElement="p" type="sh1-regular" color="neutral-on-surface">
              {i18n.t("pages.advisor.security_desc")}
            </Text>
          </Stack>

          <div className="advisor-security__panels-wrapper">
            <ul className="advisor-security__list">
              <li className="advisor-security__list-item">
                <span className="advisor-security__icon advisor-security__building" />
                <div>
                  <Stack
                    size={8}
                    line="mobile"
                    align="center"
                    justify="space-between"
                  >
                    <Stack size={0}>
                      <Text
                        htmlElement="h4"
                        type="h3-regular"
                        color="neutral-on-surface"
                      >
                        {i18n.t("pages.advisor.security_panels.panel1.title_1")}
                      </Text>
                      <Text
                        htmlElement="h4"
                        type="h3-regular"
                        color="neutral-on-surface"
                      >
                        {i18n.t("pages.advisor.security_panels.panel1.title_2")}
                      </Text>
                    </Stack>
                    <Icon
                      size={24}
                      desktopSize={42}
                      name={
                        panels.panel1 ? "arrow-circle-up" : "arrow-circle-down"
                      }
                      color="accent-tinted"
                      onClick={() =>
                        setPanels((prev) => ({ ...prev, panel1: !prev.panel1 }))
                      }
                      ariaLabel={i18n.t(
                        "pages.advisor.security_panels.panel1.button_alt_text",
                      )}
                    />
                  </Stack>
                  <CollapsePanel open={panels.panel1}>
                    <Spacer size={24} />
                    <Text
                      htmlElement="p"
                      type="body-regular"
                      color="neutral-on-surface"
                    >
                      {i18n.t(
                        "pages.advisor.security_panels.panel1.description",
                      )}
                    </Text>
                  </CollapsePanel>
                </div>
              </li>

              <li className="advisor-security__list-item">
                <span className="advisor-security__icon advisor-security__database" />
                <div>
                  <Stack
                    size={8}
                    line="mobile"
                    align="center"
                    justify="space-between"
                  >
                    <Stack size={0}>
                      <Text
                        htmlElement="h4"
                        type="h3-regular"
                        color="neutral-on-surface"
                      >
                        {i18n.t("pages.advisor.security_panels.panel2.title_1")}
                      </Text>
                      <Text
                        htmlElement="h4"
                        type="h3-regular"
                        color="neutral-on-surface"
                      >
                        {i18n.t("pages.advisor.security_panels.panel2.title_2")}
                      </Text>
                    </Stack>
                    <Icon
                      size={24}
                      desktopSize={42}
                      name={
                        panels.panel2 ? "arrow-circle-up" : "arrow-circle-down"
                      }
                      color="accent-tinted"
                      onClick={() =>
                        setPanels((prev) => ({ ...prev, panel2: !prev.panel2 }))
                      }
                      ariaLabel={i18n.t(
                        "pages.advisor.security_panels.panel2.button_alt_text",
                      )}
                    />
                  </Stack>
                  <CollapsePanel open={panels.panel2}>
                    <Spacer size={24} />
                    <Text
                      htmlElement="p"
                      type="body-regular"
                      color="neutral-on-surface"
                    >
                      {i18n.t(
                        "pages.advisor.security_panels.panel2.description",
                      )}
                    </Text>
                  </CollapsePanel>
                </div>
              </li>

              <li className="advisor-security__list-item">
                <span className="advisor-security__icon advisor-security__document" />
                <div>
                  <Stack
                    size={8}
                    line="mobile"
                    align="center"
                    justify="space-between"
                  >
                    <Stack size={0}>
                      <Text
                        htmlElement="h4"
                        type="h3-regular"
                        color="neutral-on-surface"
                      >
                        {i18n.t("pages.advisor.security_panels.panel3.title_1")}
                      </Text>
                      <Text
                        htmlElement="h4"
                        type="h3-regular"
                        color="neutral-on-surface"
                      >
                        {i18n.t("pages.advisor.security_panels.panel3.title_2")}
                      </Text>
                    </Stack>
                    <Icon
                      size={24}
                      desktopSize={42}
                      name={
                        panels.panel3 ? "arrow-circle-up" : "arrow-circle-down"
                      }
                      color="accent-tinted"
                      onClick={() =>
                        setPanels((prev) => ({ ...prev, panel3: !prev.panel3 }))
                      }
                      ariaLabel={i18n.t(
                        "pages.advisor.security_panels.panel3.button_alt_text",
                      )}
                    />
                  </Stack>
                  <CollapsePanel open={panels.panel3}>
                    <Spacer size={24} />
                    <Text
                      htmlElement="p"
                      type="body-regular"
                      color="neutral-on-surface"
                    >
                      {i18n.t(
                        "pages.advisor.security_panels.panel3.description",
                      )}
                    </Text>
                  </CollapsePanel>
                </div>
              </li>
            </ul>
          </div>
          <Stack size={24}>
            <Text
              htmlElement="h3"
              type="sh1-xbold"
              color="neutral-on-surface"
              uppercase
            >
              {i18n.t("pages.advisor.your_advantage")}
            </Text>
            <Text htmlElement="p" type="sh1-regular" color="neutral-on-surface">
              {i18n.t("pages.advisor.your_advantage_desc")}
            </Text>
          </Stack>
        </Stack>
      </Container>
    </section>
  );
}
